import type { BoxProps } from '@mui/material/Box';
import { varFade } from '@/components/animate';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { m } from 'framer-motion';
import { Button, useTheme } from '@mui/material';
import { SimpleActionSection } from '@/types/sections/SimpleActionSection';
import { varAlpha } from 'minimal-shared/utils';
import { getCtaUrl } from '@/types/Cta';
import Icon, { getIconName } from '@/components/Icon/Icon';

type SimpleActionProps = BoxProps & {
  section: SimpleActionSection;
};

export default function SimpleAction({ sx, section, ...other }: SimpleActionProps) {
  const theme = useTheme();

  return (
    <Box
      sx={[
        (theme) => ({
          px: 3,
          py: 8,
          textAlign: 'center',
          background: `linear-gradient(to left, ${varAlpha(theme.vars.palette.grey['500Channel'], 0.08)}, transparent)`,
        }),
      ]}
    >
      {section?.small && (
        <m.div variants={varFade('inDown')}>
          <Typography variant="overline" sx={{ color: 'text.disabled' }}>
            {section?.small}
          </Typography>
        </m.div>
      )}

      {section?.title && (
        <m.div variants={varFade('inUp')}>
          <Typography variant="h4" sx={{ my: 3, color: 'primary.main' }}>
            {section?.title}
          </Typography>
        </m.div>
      )}

      {section?.subtitle && (
        <m.div variants={varFade('inUp')}>
          <Typography sx={{ mx: 'auto', my: 3, maxWidth: 640, color: 'text.secondary' }}>
            {section?.subtitle}
          </Typography>
        </m.div>
      )}

      {section?.cta1 && (
        <m.div variants={varFade('in')}>
          <Button
            color="primary"
            sx={{ 
              borderRadius: 0,
            }}
            variant="contained"
            href={getCtaUrl(section.cta1)}
            startIcon={ section?.cta1?.icon && (
                <Icon name={getIconName(section?.cta1?.icon, 'unknown')} color={theme.palette.common.white} />
              )}
          >
            {section?.cta1?.title}
          </Button>
        </m.div>
      )}
    </Box>
  );
}
